import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import BiographySection from '@/components/BiographySection';
import PoliticalCareerSection from '@/components/PoliticalCareerSection';
import AchievementsSection from '@/components/AchievementsSection';
import VisionSection from '@/components/VisionSection';
import GallerySection from '@/components/GallerySection';
import SpeechesSection from '@/components/SpeechesSection';
import NewsSection from '@/components/NewsSection';
import Footer from '@/components/Footer';

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <BiographySection />
        <PoliticalCareerSection />
        <AchievementsSection />
        <VisionSection />
        <GallerySection />
        <SpeechesSection />
        <NewsSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;